module.exports = __webpack_public_path__ + "static/ceo3-d4ec0669590d9c2a039f62a2002a63ad.jpg";